(function() {
  function parseLaunchDate(value) {
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? null : time;
  }

  function syncGate(gate) {
    const target = parseLaunchDate(gate.dataset.launch);
    const waiting = gate.querySelector('[data-launch-waiting]');
    const live = gate.querySelector('[data-launch-live]');
    const isLive = !target || target <= Date.now();

    if (waiting) {
      waiting.hidden = isLive;
      waiting.style.display = isLive ? 'none' : '';
    }

    if (live) {
      live.hidden = !isLive;
      live.style.display = isLive ? '' : 'none';
    }

    gate.classList.toggle('launch-countdown-gate--live', isLive);
  }

  function syncSticky(sticky) {
    const target = parseLaunchDate(sticky.dataset.launch);
    const isLive = !target || target <= Date.now();

    sticky.hidden = !isLive;
    sticky.style.display = isLive ? '' : 'none';
  }

  function syncBanner(banner) {
    const target = parseLaunchDate(banner.dataset.launch);
    const isLive = !target || target <= Date.now();

    if (!isLive) {
      banner.hidden = false;
      banner.style.display = '';
      banner.classList.remove('launch-banner--live');
      return;
    }

    if (banner.dataset.hideAfter === 'true') {
      banner.hidden = true;
      banner.style.display = 'none';
    } else {
      banner.hidden = false;
      banner.style.display = '';
      banner.classList.add('launch-banner--live');
    }
  }

  function syncAllLaunchElements() {
    document.querySelectorAll('[data-launch-gate]').forEach(syncGate);
    document.querySelectorAll('[data-launch-sticky]').forEach(syncSticky);
    document.querySelectorAll('.launch-banner[data-launch]').forEach(syncBanner);
  }

  if (!customElements.get('launch-countdown')) {
    class LaunchCountdown extends HTMLElement {
      connectedCallback() {
        this.target = parseLaunchDate(this.dataset.launch);
        if (!this.target) {
          this.finish();
          return;
        }

        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.mins = this.querySelector('[data-mins]');
        this.secs = this.querySelector('[data-secs]');
        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      pad(value) {
        return value < 10 ? '0' + value : String(value);
      }

      tick() {
        const diff = this.target - Date.now();

        syncAllLaunchElements();

        if (diff <= 0) {
          this.finish();
          return;
        }

        if (!this.days || !this.hours || !this.mins || !this.secs) {
          return;
        }

        this.days.textContent = this.pad(Math.floor(diff / 86400000));
        this.hours.textContent = this.pad(Math.floor((diff % 86400000) / 3600000));
        this.mins.textContent = this.pad(Math.floor((diff % 3600000) / 60000));
        this.secs.textContent = this.pad(Math.floor((diff % 60000) / 1000));
      }

      finish() {
        clearInterval(this.interval);

        if (this.days && this.hours && this.mins && this.secs) {
          this.days.textContent = '00';
          this.hours.textContent = '00';
          this.mins.textContent = '00';
          this.secs.textContent = '00';
        }

        syncAllLaunchElements();
      }
    }

    customElements.define('launch-countdown', LaunchCountdown);
  }

  syncAllLaunchElements();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllLaunchElements);
  }
})();
